import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';

async function createCalculation(templateId: string, workpaperId: string): Promise<{ calculationId: string }> {
    const { data } = await api.post(`/workpapers/${workpaperId}/worksheets/calculations`, { templateId });
    return data;
}

export function useCreateCalculation(): UseMutationResult<{ calculationId: string }, unknown, { templateId: string }, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation(({ templateId }) => createCalculation(templateId, workpaperId));
}
